// test272
(272 && 0);
